import React from 'react';
import  './Spinner.scss';

const spinner = () => <div className={"SpinnerLoader"} />;
export default spinner;
